module.exports = __webpack_public_path__ + "bdf7ba8f.png";